//mousewheeleventのクロスブラウザ対策
if('onwheel' in document){
	var mousewheelevent = 'wheel';
}else if('onmousewheel' in document){
	var mousewheelevent = 'mousewheel';
}else{
	var mousewheelevent = 'DOMMouseScroll';
}


function serviceIndex(){
	if($('.wrap')[0].getAttribute('data-page') == 'service__index'){
		const height = $(window).height();
		$(window).scrollTop(0);
		setTimeout(function(){
			$('body[data-page="service__index"]').css('overflow', 'hidden');
			$('.container[data-page="service__index"]').css('display', 'none');
			$('.wrap[data-page="service__index"] .mainvisual--title').css('height', height + 'px');
			$('.wrap[data-page="service__index"] .mainvisual--text').css('height', height + 'px');
		}, 100);
		$(window).on('scroll',function(e){
			var top = $(window).scrollTop()
			if(top > height){
				$('.wrap[data-page="service__index"] .mainvisual--text').hide();
			}else{
				$('.wrap[data-page="service__index"] .mainvisual--text').show();
			}
		})
	}
	$(window).on(mousewheelevent,function(e){
		if($('.wrap')[0].getAttribute('data-page') == 'service__index'){
			if(e.originalEvent.deltaY){
				var delta = -(e.originalEvent.deltaY);
			}else if(e.originalEvent.wheelDelta){
				var delta = e.originalEvent.wheelDelta;
			}else{
				var delta = -(e.origtruevent.detail);
			}
			console.log();
			if(delta < 0){
				$('.wrap[data-page="service__index"] .mainvisual .message--service').addClass('is--scroll');
				$('.wrap[data-page="service__index"] .mainvisual h2').addClass('is--hide');
				setTimeout(function(){
					$('body[data-page="service__index"]').removeAttr('style');
					$('.container[data-page="service__index"]').removeAttr('style');
				}, 1000);
				$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').addClass('is--visible');
				$('.wrap[data-page="service__index"] .mainvisual .overray').addClass('is--visible');
			}else if(delta > 0 && $(window).scrollTop() == 0){
				$('body[data-page="service__index"]').css('overflow', 'hidden');
				$('.container[data-page="service__index"]').css('display', 'none');
				$('.wrap[data-page="service__index"] .mainvisual h2').removeClass('is--hide');
				$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').removeClass('is--visible');
				$('.wrap[data-page="service__index"] .mainvisual .overray').removeClass('is--visible');
			}
		}
	});
	$('html').keyup(function(e){
        switch(e.which){  
            case 34:
			case 40:
				$('.wrap[data-page="service__index"] .mainvisual .message--service').addClass('is--scroll');
				$('.wrap[data-page="service__index"] .mainvisual h2').addClass('is--hide');
				setTimeout(function(){
					$('body[data-page="service__index"]').removeAttr('style');
					$('.container[data-page="service__index"]').removeAttr('style');
				}, 1000);
				$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').addClass('is--visible');
				$('.wrap[data-page="service__index"] .mainvisual .overray').addClass('is--visible');
			break;
			case 33:
			case 38:
				if($(window).scrollTop() == 0){
					$('body[data-page="service__index"]').css('overflow', 'hidden');
					$('.container[data-page="service__index"]').css('display', 'none');
					$('.wrap[data-page="service__index"] .mainvisual h2').removeClass('is--hide');
					$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').removeClass('is--visible');
					$('.wrap[data-page="service__index"] .mainvisual .overray').removeClass('is--visible');
				}
			break;
		}
    });
	// $(window).on('scroll',function(){
	// 	var top = $(window).scrollTop();
	// 	const height = $(window).height();
	//
	// 	if(top > 50){
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--title h2').addClass('is--hide');
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').addClass('is--visible');
	// 		$('.wrap[data-page="service__index"] .mainvisual .overray').addClass('is--visible');
	// 	}else if(top <= 50){
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--title h2').removeClass('is--hide');
	// 		$('.wrap[data-page="service__index"] .mainvisual .mainvisual--text .text').removeClass('is--visible');
	// 		$('.wrap[data-page="service__index"] .mainvisual .overray').removeClass('is--visible');
	// 	}
	//
	// });
}

module.exports = serviceIndex;






// WEBPACK FOOTER //
// ./es2015/_service_index.js